var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.025 21.325L7.825 16.825L0.625 21.325V1.525C0.625 1.28631 0.719821 1.05739 0.888604 0.888604C1.05739 0.719821 1.28631 0.625 1.525 0.625H14.125C14.3637 0.625 14.5926 0.719821 14.7614 0.888604C14.9302 1.05739 15.025 1.28631 15.025 1.525V21.325Z",
    fill: "#0066CC",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmarked.ca1cf7e9a13c92db3229aa0cbefc0485.svg";